import { CommonModule } from '@angular/common';
import { Component, ContentChildren, Input, QueryList, ViewChild } from '@angular/core';
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule, MatMenuTrigger } from '@angular/material/menu';
import { IconComponent, IconType, IconFamily } from 'components/layout/icon/icon.component';

@Component({
	selector: 'menu menuitem',
	template: '<button mat-menu-item [title]="title ? title : \'\'" [disabled]="disabled">@if (iconType) {<icon [type]="iconType" [family]="iconFamily"></icon>}<ng-content></ng-content></button>',
	imports: [MatMenuModule, IconComponent]
})
export class MenuItemComponent {
	@Input() title?: string;
	@Input() disabled = false;
	@Input('icon') iconType?: IconType;
	@Input('icon-family') iconFamily?: IconFamily;
}

@Component({
	selector: 'menu', templateUrl: './menu.component.html', styleUrls: ['./menu.component.scss'],
	imports: [MatButtonModule, MatMenuModule, MatIconModule, CommonModule]
})
export class MenuComponent {

	@ContentChildren(MenuItemComponent) menuitems?: QueryList<MenuItemComponent>;

	public active = false;

	@Input() visibleItems = 1;
	@Input() visibleMenuButton = true;

	constructor() { }

	@ViewChild(MatMenuTrigger) private menuStatus?: MatMenuTrigger;

	get menuIsOpen() {
		return this.menuStatus ? this.menuStatus.menuOpen : false;
	}
}
